import { getWindow } from './app-window';
import { isAndroid } from './is-android';
export function isAndroidPad() {
    var _a, _b;
    return (isAndroid() && !navigator.userAgent.toLowerCase().includes('mobile'))
        || (isAndroid() && ((_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.screen) === null || _b === void 0 ? void 0 : _b.width) > 600);
}
